@if(service.viewDroplistItems.length){
<div class='delivery-accelerators-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Accelerator) {
	<delivery-accelerators-view-part></delivery-accelerators-view-part>
	}
	}
	}
</div>
}